import pipe from "../lib/core/functional/pipe";
import { isUserLoggedIn } from "../utils/loggedInControl.js";

import { retrieveJsonRequest } from "./utils";

const DATA_ENDPOINT = "load_more_posts/data.js";

const nodePageNumber = {};

function makeBaseRequestParams(context) {
    return {
        site_id: context.bootstrap.site.id,
        node_id: context.sklId,
        resource_id: context.bootstrap.resourceId,
        path_params: JSON.stringify(context.bootstrap.pathParams),
        rm_page_path: context.path,
        formats: "html",
        ...(context.bootstrap.tag?.isSection && { is_section_tag: 1 }),
        ...context.pathParams,
    };
}

function makeNextPageParams(context) {
    if (!(context.sklId in nodePageNumber)) {
        nodePageNumber[context.sklId] = 1;
    }
    return {
        ...makeBaseRequestParams(context),
        rm_lazy_load: 1,
        exclude_post_ids: context.excludePostIds,
        pn: nodePageNumber[context.sklId],
        last_post_id: context.lastPostId,
        pn_strategy: context.ignorePageNumber ? "ignore" : "",
    };
}

function makeLiveBlogParams(context) {
    return {
        ...makeBaseRequestParams(context),
        post_id: context.postId,
        override_device: "desktop",
    };
}

function makeCoreUrl(params) {
    return [`/core/${DATA_ENDPOINT}`, params];
}

function makeResUrl(params) {
    return [`/res/${DATA_ENDPOINT}`, params];
}

function appendQueryParams([url, params]) {
    return `${url}?${new URLSearchParams(params).toString()}`;
}

const getLiveBlogUrl = pipe(makeLiveBlogParams, makeResUrl, appendQueryParams);
const getLoggedOutNextPageUrl = pipe(makeNextPageParams, makeResUrl, appendQueryParams);
const getLoggedInNextPageUrl = pipe(makeNextPageParams, makeCoreUrl, appendQueryParams);

function updatePageNumber(data) {
    nodePageNumber[data.node_id]++;
    return [data, nodePageNumber[data.node_id]];
}

export function dispatchNextPage(context) {
    const urlMaker = isUserLoggedIn() ? getLoggedInNextPageUrl : getLoggedOutNextPageUrl;
    return retrieveJsonRequest(urlMaker(context)).then(updatePageNumber);
}

export function dispatchLivePostUpdate(context) {
    return retrieveJsonRequest(getLiveBlogUrl(context));
}
